import * as priceFragments from '@/services/price/fragments';

export default `
mutation update_vendor(
  $vendor: [vendor_insert_input!]!
  $delete_component_ids: [uuid!]!
  $delete_material_ids: [uuid!]!
  ${priceFragments.mutationArgs}
) {
  ${priceFragments.mutations}

  insert_vendor(
    objects: $vendor,
    on_conflict: {
      constraint: vendor_pkey,
      update_columns: [
        name
        contact
        notes
      ]
    }
  ) {
    affected_rows
    returning {
      id
    }
  }

  delete_vendor_component(
    where: {
      id: {
        _in: $delete_component_ids
      }
    }
  ) {
    affected_rows
    returning {
      id
    }
  }

  delete_vendor_material(
    where: {
      id: {
        _in: $delete_material_ids
      }
    }
  ) {
    affected_rows
    returning {
      id
    }
  }
}
`;
